import { makeStyles } from '@mui/styles';

const useStyles = makeStyles(() => ({
  accessoriesWrapper: {
    display: 'flex',
    flexDirection: 'column',
  },

}));

export default useStyles;
